import { Button, Col, Row } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { theme } from '../../../assets/theme';
import { RightOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';

const ProductIntroCard = ({ image, title, text, imagePlacement, viewProductsLink, isTabletOrMobile }) => {
    const [isVisible, setIsVisible] = useState(false);
    const rowRef = useRef(null);
    const rowRef2 = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (rowRef.current) {
            observer.observe(rowRef.current);
        }

        if (rowRef2.current) {
            observer.observe(rowRef2.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <>
            {imagePlacement === "left" ?
                <Row ref={rowRef}>
                    <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                        <img
                            src={image}
                            className={`slide-in-left ${isVisible ? 'visible' : ''}`}
                            style={{
                                height: 400,
                                width: "90%",
                                borderTopRightRadius: 50,
                                borderBottomRightRadius: 50
                            }}
                        />
                    </Col>
                    <Col
                        xl={12}
                        lg={12}
                        md={24}
                        sm={24}
                        xs={24}
                        className={`slide-in-right ${isVisible ? 'visible' : ''}`}
                        style={{
                            textAlign: "left",
                            paddingTop: !isTabletOrMobile && 60,
                            paddingLeft: isTabletOrMobile && 18
                        }}
                    >
                        <span className='product-intro-title'>
                            {title}
                        </span>
                        <p className='product-intro-text'>
                            {text}
                        </p>
                        <Button
                            type='default'
                            className='intro-button'
                            onClick={() => navigate(viewProductsLink)}
                        >
                            View Products <RightOutlined />
                        </Button>
                    </Col>
                </Row>
                : <>
                    {!isTabletOrMobile ?
                        <Row ref={rowRef2}>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24} style={{ textAlign: "right", paddingTop: 60, paddingBottom: 60 }}>
                                <span className='product-intro-title'>{title}</span>
                                <p className='product-intro-text '>
                                    {text}
                                </p>
                                <Button type='default' className='intro-button' onClick={() => navigate(viewProductsLink)}>View Products<RightOutlined /></Button>
                            </Col>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24}
                                className={`slide-in-left ${isVisible ? 'visible' : ''}`}
                                style={{
                                    textAlign: "right",
                                    paddingTop: !isTabletOrMobile && 60,
                                    paddingLeft: isTabletOrMobile && 18.,
                                }}>
                                <img src={image}
                                    className={`slide-in-right ${isVisible ? 'visible' : ''}`}
                                    style={{
                                        height: 400,
                                        width: "90%",
                                        borderTopRightRadius: 50,
                                        borderBottomRightRadius: 50
                                    }} />
                            </Col>
                        </Row>
                        :
                        <Row>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24} style={{ justifyContent: "flex-end", display: "flex" }}>
                                <img src={image} style={{ height: 400, width: "90%", borderTopLeftRadius: 50, borderBottomLeftRadius: 50 }} />
                            </Col>
                            <Col xl={12} lg={12} md={24} sm={24} xs={24} style={{ textAlign: "right", paddingRight: 18 }}>
                                <span className='product-intro-title'>{title}</span>
                                <p className='product-intro-text '>
                                    {text}
                                </p>
                                <Button type='default' className='intro-button' onClick={() => navigate(viewProductsLink)}>View Products<RightOutlined /></Button>
                            </Col>
                        </Row>}
                </>
            }

        </>
    );
}

export default ProductIntroCard;